import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


// 把VueRouter原型对象push，保存一份
let originPush = VueRouter.prototype.push
let originReplace=VueRouter.prototype.replace
 
// 重写push|replace
// 第一个参数：告诉原来的push方法，往哪里跳转（传递哪些参数）
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => { }, () => { })
    }
}
VueRouter.prototype.replace=function(location,resolve,reject){
    if(resolve&&reject){
        originReplace.call(this,location,resolve,reject)
    }else{
        originReplace.call(this,location,()=>{},()=>{})
    }
}

const routes = [
    {
        path: '/',
        component: resolve => require(['@/views/home'], resolve),
        children: [
            { path: '/', component: resolve => require(['@/views/Video/videolist.vue'], resolve) },
            {
                path: '/user', component: resolve => require(['@/components/left.vue'], resolve),
                children:
                    [
                        { name: "update", path: '/update', component: resolve => require(['@/views/Video/update.vue'], resolve) },
                        { name: "userVideo", path: '/userVideo', component: resolve => require(['@/views/Video/userVideo.vue'], resolve) },
                    ]
            },
        ]
    },
    { path: '/login', component: resolve => require(['@/views/login.vue'], resolve) },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})


export default router